import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Add from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import {
	addPackage,
	changePackagesOrder,
	deletePackage,
	resetRepeatedRoutes,
	getRoute,
} from 'actions/DeliveryRoutes';
import { moveArrayElementDown, moveArrayElementUp } from 'utils/arrayUtils';
import NewPackageDialog from '../components/NewPackageDialog';
import PackagesList from '../components/PackagesList';
import RouteDetail from '../components/RouteDetail';
import RouteMap from '../components/RouteMap';
import styles from '../styles.css';

class SelectedRouteContainer extends React.Component {
	formatRepeatedRoutesString() {
		let formattedString = '';
		this.props.repeatedRoutesContainer.data.forEach(element => {
			const periodName = element.period ? element.period.name : '';
			formattedString = `${formattedString} ${element.number}-${periodName}, `;
		});
		return formattedString;
	}

	renderCheckRepeatedRoute() {
		if (
			this.props.repeatedRoutesContainer &&
			this.props.repeatedRoutesContainer.data &&
			this.props.repeatedRoutesContainer.data.length > 0
		) {
			return (
				<Dialog open>
					<DialogTitle id="alert-dialog-title">Por favor, confirme sua ação.</DialogTitle>
					<DialogContentText className={styles.checkDialogText}>
						{`O pedido #${
							this.props.repeatedRoutesContainer.order
						} está presente também nas rotas: ${this.formatRepeatedRoutesString()}. Tem certeza que quer adicionar o pedido novamente?`}
					</DialogContentText>
					<DialogActions>
						<Button
							onClick={() => {
								this.handleAddNewPackage({
									order: this.props.repeatedRoutesContainer.order,
									force: true,
								});
								this.props.resetRepeatedRoutes();
							}}
						>
							Sim
						</Button>
						<Button onClick={this.props.resetRepeatedRoutes}>Cancelar</Button>
					</DialogActions>
				</Dialog>
			);
		}
		return null;
	}

	constructor(props) {
		super(props);
		this.state = {
			productDialogOpen: false,
		};
	}

	componentDidUpdate(prevProps) {
		if (
			this.props.selectedRouteId &&
			this.props.selectedRouteId !== prevProps.selectedRouteId
		) {
			this.props.getRoute(this.props.selectedRouteId);
		}
	}

	getPackagesOrderArray() {
		const { route } = this.props;
		if (!route) {
			return [];
		}
		return route.packages.map(pack => pack.order);
	}

	handleChangePackagePosition = (order, direction) => {
		const packagesOrder = this.getPackagesOrderArray();
		const index = packagesOrder.indexOf(order);
		let newOrder;
		if (index === -1) {
			return;
		}
		if (direction === 1) {
			newOrder = moveArrayElementUp(packagesOrder, index);
		} else if (direction === -1) {
			newOrder = moveArrayElementDown(packagesOrder, index);
		}
		if (newOrder) {
			const { route } = this.props;
			this.props.changePackagesOrder({
				deliveryRouteId: route._id,
				packagesOrder: newOrder,
			});
		}
	};

	handleDeletePackage = order => {
		const { route } = this.props;
		this.props.deletePackage({
			deliveryRouteId: route._id,
			order,
		});
	};

	handleOpenNewPackageDialog = () => {
		this.setState({
			productDialogOpen: true,
		});
	};

	handleCloseNewPackageDialog = () => {
		this.setState({
			productDialogOpen: false,
		});
	};

	handleAddNewPackage = ({ order, callback, force }) => {
		const { route } = this.props;
		this.props.addPackage({
			deliveryRouteId: route._id,
			order,
			callback,
			force: force || false,
		});
	};

	renderRoutePackages() {
		const { route } = this.props;
		return (
			<Grid item>
				<PackagesList
					route={route}
					onChangePackagePosition={this.handleChangePackagePosition}
					onDeletePackage={this.handleDeletePackage}
				/>
				<Button
					fullWidth
					variant="outlined"
					color="default"
					className="jr-btn-xs text-blue-gray"
					onClick={this.handleOpenNewPackageDialog}
				>
					<Add className={styles.addPackage} />
					Adicionar pedido
				</Button>
				<NewPackageDialog
					onAdd={this.handleAddNewPackage}
					onClose={this.handleCloseNewPackageDialog}
					open={this.state.productDialogOpen}
				/>
			</Grid>
		);
	}

	render() {
		const { loading, route, cdLocation } = this.props;
		if (loading) {
			return <CircularProgress />;
		}
		if (!route) {
			return null;
		}

		return (
			<Grid container direction="column" spacing={16}>
				<Grid item>
					<RouteDetail />
				</Grid>
				<Grid item>
					<Grid container direction="row">
						<Grid item xs={6}>
							{this.renderRoutePackages()}
						</Grid>
						<Grid item xs={6}>
							<RouteMap cdLocation={cdLocation} route={route} />
						</Grid>
					</Grid>
				</Grid>
				{this.renderCheckRepeatedRoute()}
			</Grid>
		);
	}
}

SelectedRouteContainer.propTypes = {
	route: PropTypes.object,
	loading: PropTypes.bool,
	cdLocation: PropTypes.object,
	changePackagesOrder: PropTypes.func.isRequired,
	deletePackage: PropTypes.func.isRequired,
	addPackage: PropTypes.func.isRequired,
	getRoute: PropTypes.func.isRequired,
	resetRepeatedRoutes: PropTypes.func.isRequired,
	selectedRouteId: PropTypes.string,
	repeatedRoutesContainer: PropTypes.shape({
		data: PropTypes.array,
		order: PropTypes.number,
		loading: PropTypes.bool,
		error: PropTypes.string,
	}),
};

const mapStateToProps = state => ({
	route: state.deliveryRoutes.routeContainer.data,
	loading: state.deliveryRoutes.routeContainer.loading,
	selectedRouteId: state.deliveryRoutes.selectedRouteId,
	repeatedRoutesContainer: state.deliveryRoutes.repeatedRoutesContainer,
	cdLocation: state.distributionCenters.selectedAddress,
});

export default connect(
	mapStateToProps,
	{
		changePackagesOrder,
		deletePackage,
		addPackage,
		resetRepeatedRoutes,
		getRoute,
	}
)(SelectedRouteContainer);
